import { render, staticRenderFns } from "./SignatureBox.vue?vue&type=template&id=177227f3&scoped=true&"
import script from "./SignatureBox.vue?vue&type=script&lang=js&"
export * from "./SignatureBox.vue?vue&type=script&lang=js&"
import style0 from "./SignatureBox.vue?vue&type=style&index=0&id=177227f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177227f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
